"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _formAdd = _interopRequireDefault(require("@/components/formAdd.vue"));
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    FormAdd: _formAdd.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          objectName: [{
            required: true,
            message: "请输入项目名称",
            trigger: "blur"
          }],
          objectType: [{
            required: true,
            message: "请输入项目类型",
            trigger: "blur"
          }]
        },
        labelWidth: "150px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [{
          type: "input",
          label: "作品项名称",
          isDisabled: false,
          placeholder: "请输入作品项名称",
          prop: "objectName",
          value: ""
        }, {
          type: "select",
          label: "作品文件类型",
          isDisabled: false,
          placeholder: "请输入作品文件类型",
          prop: "objectType",
          value: [],
          options: [{
            name: "JavaScript",
            value: "JavaScript",
            isDisabled: true
          }, {
            name: "Java",
            value: "Java",
            isDisabled: false
          }]
        }, {
          type: "suffix",
          label: "作品文件大小",
          isDisabled: false,
          placeholder: "请输入作品文件大小",
          prop: "objectYear",
          value: '',
          suffix: "M"
        }, {
          type: "limit",
          label: "作品文件上传要求",
          isDisabled: false,
          placeholder: "请输入作品文件上传要求",
          prop: "objectYear",
          value: '',
          maxlength: 300
        }],
        addForm: true
      }
    };
  },
  methods: {
    addItem: function addItem() {
      this.formData.formAddItem.push({
        label: "材料名称",
        isDisabled: false,
        placeholder: "请输入材料名称",
        prop: "materialsName",
        value: '',
        span: 20
      });
    },
    removeItem: function removeItem(item) {
      var index = this.formData.formAddItem.indexOf(item);
      if (index !== -1) {
        this.formData.formAddItem.splice(index, 1);
      }
    }
  }
};